import { useContext } from 'react'
import { ThankyouContext } from '../components/ThankyouProvider/ThankyouProvider'

export function useThankyou() {
  const thankyouContext = useContext(ThankyouContext)

  if (!thankyouContext) throw new Error('ThankyouContext has to be used within <ThankyouContext.Provider>')

  return thankyouContext
}
